import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Tooltip } from '@mui/material';
import { SCUICustomDataGrid } from '../../../../../atomic/molecules';
import TimeHelper from '../../../../../utils/time';
import { SCUILoading } from '../../../../../atomic/atoms';
import Helper from '../../../../../utils/helper';

export const SCUIRefundDetailCustomerInfo: FC<{
    paymentResult?: any;
}> = ({ paymentResult }) => {
    const { t } = useTranslation();
    const columns: ExtendedGridColDef[] = [
        {
            field: 'paymentId',
            headerName: t('refund.paymentId'),
            width: 100,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.row.paymentId}>
                        <div>{params.row.paymentId}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'orderNumber',
            headerName: t('refund.orderNo'),
            width: 100,
            renderCell: (params) => {
                return (
                    <div>
                        <a
                            style={{ color: 'blue', textDecoration: 'underline' }}
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`/orderDetail?OrderNumber=${params.row.orderNumber}`}
                        >
                            {params.row.orderNumber}
                        </a>
                    </div>
                );
            },
        },
        {
            field: 'createDate',
            headerName: t('refund.createDate'),
            flex: 1,
            renderCell: (params) => {
                return <div>{TimeHelper.formatDateHourSecond(params.row.createDate)}</div>;
            },
        },
        {
            field: 'completeDate',
            headerName: t('refund.completeDate'),
            flex: 1,
            renderCell: (params) => {
                return <div>{TimeHelper.formatDateHourSecond(params.row.completeDate)}</div>;
            },
        },
        {
            field: 'paymentAmount',
            headerName: t('refund.expectedAmount'),
            width: 150,
            renderCell: (params) => {
                return (
                    <Tooltip title={`${Helper.formatNumber(params.row.paymentAmount)} ${params.row.currencySymbol}`}>
                        <div>{`${Helper.formatNumber(params.row.paymentAmount)} ${params.row.currencySymbol}`}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'confirmedAmount',
            headerName: t('refund.paymentAmount'),
            width: 200,
            renderCell: (params) => {
                return (
                    <Tooltip title={`${Helper.formatNumber(params.row.confirmedAmount)} ${params.row.currencySymbol}`}>
                        <div>{`${Helper.formatNumber(params.row.confirmedAmount)} ${params.row.currencySymbol}`}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'paymentMethodName',
            headerName: t('refund.paymentMethod'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            <h1>
                                {Helper.getPaymentName(
                                    params.row.paymentMethodId,
                                    params.row.walletPaymentModelData && params.row.walletPaymentModelData.walletTypeId
                                )}
                            </h1>
                        }
                    >
                        <div>
                            {Helper.getPaymentName(
                                params.row.paymentMethodId,
                                params.row.walletPaymentModelData && params.row.walletPaymentModelData.walletTypeId
                            )}
                        </div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'paymentStatusDescription',
            headerName: t('general.status'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.paymentStatusName}</h1>}>
                        <div>{params.row.paymentStatusDescription}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'creditCardTypeName',
            headerName: t('refund.creditCardInfo'),
            flex: 1,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.creditCartPaymentModelData &&
                            params.row.creditCartPaymentModelData.creditCardTypeName}
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <Grid
                size={{
                    sm: 12,
                    md: 6,
                    lg: 4,
                    xl: 3,
                }}
            ></Grid>
            {paymentResult && paymentResult.items ? (
                <SCUICustomDataGrid randomId rows={paymentResult.items} columns={columns} />
            ) : (
                <SCUILoading />
            )}
        </>
    );
};
